<template>
  <div class="ui-flex ui-flex-pack-center login-panel">
    <div>
      <img src="/static/img/big_logo.png" width="220px"  style="margin: 100px;" />
    </div>
    <div class="login-win" >
      <div class="input-container" >
        <div>
          <input v-model="mobile" class="input-user1 " placeholder="请输入手机号"/>
        </div>
        <div>
          <input type="password" v-model="pwd" class="input-password" style="width:97%;" placeholder="请输入密码"/>
        </div>
        <div>
          <input v-model="code" class="input-password1 " placeholder="请输入验证码"/>
          <button class="code" v-on:click="sendmsg()" >发送验证码</button>
        </div>
        
        <div class="error" style="text-align: center" >{{error}}</div>
        <button v-on:click="register()" class="button-login margin-top-45">
                注册
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'register',
  data () {
    return {
      mobile:"",
      pwd:"",
      code:"",
      error:""
    }
  },
  methods:{
    sendmsg: function(){
      var sendflag = this.$store.state.sendflag;
      if(sendflag=="1"){
        return ;
      }
      var self = this;
      if(this.mobile==''){
        self.error = "请输入手机号";
        return ;
      }
      this.$http.post('/ZYun/HttpService.do', {
        "serviceCode":"1003",
        "phoneNo":this.mobile,
        "smsType":"1",
        "smsValidTime":"600"
      })
        .then((response) => {
          if(response.data.respCode=="0000"){
            self.$store.state.sendflag = "1";
            var i = 60;
            var t1 = window.setInterval(function(){
              $(".code").html(i+"（秒）");
              i--;
              if(i==-2){
                self.$store.state.sendflag = "0";
                $(".code").html("发送验证码");
                window.clearInterval(t1);
              }
            },1000);
          }else{
            self.error = response.data.respMsg;
          }
        })
        .catch((response) =>{
          console.log(response);
        });
    },
    register:function(){
      var self = this;
      if(this.mobile==''){
        self.error = "请输入手机号";
        return ;
      }
      if(this.pwd==''){
        self.error = "请输入密码";
        return ;
      }
      if(this.pwd.length < 6){
        self.error = "请输入密码少于6位";
        return ;
      }
      if(this.code==''){
        self.error = "请输入验证码";
        return ;
      }
      this.$http.post('/ZYun/HttpService.do', {
        "serviceCode":"1001",
        "userName":this.mobile,
        "userPwd":this.pwd,
        "userPwd2":this.pwd,
        "smsCode":this.code
      })
        .then((response) => {
          if(response.data.respCode=="0000"){
            this.$store.state.uid = response.data.uId;
            this.$router.push("/login");
          }else{
            self.error = response.data.respMsg;
          }
        })
        .catch((response) =>{
          console.log(response);
        });
    }
  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../../static/css/login.css">

</style>



// WEBPACK FOOTER //
// src/components/register.vue